const services = [
    {
        num: "01",
        title: "Construction haut de gamme",
        subtitle: "Maisons individuelles · matériaux nouvelle génération",
        text: "Conception architecturale, gros œuvre performant, matériaux innovants (briques monomur, isolation biosourcée, domotique intégrée). Une maison contemporaine, durable et sur mesure — jusqu'à la remise des clés.",
        img: "https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/0qvm7kgm_IMG-20260819-WA0030.jpg",
    },
    {
        num: "02",
        title: "Rénovation haut de gamme",
        subtitle: "Bois massif · pierre naturelle · applications modernes",
        text: "Nous conjuguons matériaux nobles — parquets massifs, pierres de taille, marbres, essences rares — et innovations récentes : plancher chauffant, vitrages performants, éclairage scénographique.",
        img: "https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/f3vsko5x_Messenger_creation_FE4A9381-4F6A-433E-A8B2-A31652248940.webp",
    },
    {
        num: "03",
        title: "Maîtrise d'œuvre",
        subtitle: "Plans techniques · direction de projet",
        text: "Étude architecturale, plans d'exécution, coordination multi-corps d'état et suivi de chantier. Un interlocuteur unique orchestre chaque intervention, chaque livraison, chaque détail — jusqu'à la remise des clés.",
        img: "https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/s3tl251p_Screenshot_20260811_190200_Photos.webp",
    },
];

export default function Services() {
    return (
        <section
            id="services"
            data-testid="services"
            className="py-32 bg-[#F2EEE5] relative"
        >
            <div className="max-w-[1500px] mx-auto px-6 md:px-12">
                <div className="flex items-end justify-between flex-wrap gap-8 mb-20 section-fade">
                    <div className="max-w-2xl">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="h-px w-10 bg-[#B89C6A]" />
                            <span className="tracking-luxe text-[#B89C6A]">
                                Savoir-faire
                            </span>
                        </div>
                        <h2 className="font-serif-lux text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
                            Trois disciplines,
                            <br />
                            une <em className="italic text-[#B89C6A]">
                                exigence
                            </em>{" "}
                            unique.
                        </h2>
                    </div>
                    <p className="max-w-sm text-[15px] leading-relaxed text-[#1C1E1D]/70">
                        Nos équipes intégrées interviennent aussi bien sur des projets patrimoniaux que sur des programmes contemporains ambitieux.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {services.map((s) => (
                        <article
                            key={s.num}
                            data-testid={`service-${s.num}`}
                            className="group bg-[#FFFDF9] border hairline p-8 flex flex-col section-fade transition-transform duration-500 hover:-translate-y-1"
                        >
                            <div className="aspect-[4/5] overflow-hidden mb-8">
                                <img
                                    src={s.img}
                                    alt={s.title}
                                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                />
                            </div>
                            <div className="flex items-baseline gap-4">
                                <span className="font-serif-lux text-3xl text-[#B89C6A]">
                                    {s.num}
                                </span>
                                <div>
                                    <h3 className="font-serif-lux text-2xl">
                                        {s.title}
                                    </h3>
                                    <p className="tracking-luxe text-[#1C1E1D]/60 mt-1">
                                        {s.subtitle}
                                    </p>
                                </div>
                            </div>
                            <p className="mt-6 text-[14px] leading-relaxed text-[#1C1E1D]/75">
                                {s.text}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
